import Head from 'next/head';

export default function AppHead() {
  return (
    <Head>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, viewport-fit=cover"
      />
      <meta name="title" content="캐시노트 마켓" />
      <meta
        name="description"
        content="장사에 필요한 물건을 합리적인 가격으로 쉽고 편하게! 쌀, 치즈, 식용유, 햄, 종이컵 등 매일 사용하는 비품을 캐시노트 마켓에서 합리적인 가격으로 발주하세요."
      />
      <link rel="icon" href="/favicon.ico" />
      <title>캐시노트 마켓</title>
    </Head>
  );
}
